module.exports = __webpack_public_path__ + "static/media/404.f4c82894.svg";